import { Component, Mixins, Emit } from 'vue-property-decorator';
import Classes from '@groot-components/shared/mixins/classes';
import { YIcon } from '@groot-components/icon';
import config from '@groot-components/shared/config';
import Props from './props';

/**
 * @name Image
 */
@Component({
    components: {
        YIcon,
    },
})
class YImage extends Mixins(Props, Classes) {
    /**
     * Show or hidden image
     */
    display = true;

    /**
     * Props list that active by developer
     */
    activeCommonProps: Array<string> = ['sharp', 'rounded', 'raised', 'bordered', 'icon', 'color'];

    /**
     * Create Common Props for the image.
     *
     * @returns {object} - List of props
     */
    get commonProps(): Record<string, any> {
        const commonProps: Record<string, any> = {
            baseClass: this.baseClass,
        };
        this.activeCommonProps.forEach((item) => {
            commonProps[item] = this[item];
        });
        return commonProps;
    }

    /**
     * Create classes array for the image-wrapper.
     *
     * @returns {Array} - Array of classes
     */
    get classes(): Array<string> {
        const cls: Array<string> = [];
        cls.push(...this.commonClasses('Image', this.commonProps, this.baseClass || config.prefix.image));
        if (this.circle) {
            cls.push('is-circle');
        }
        if (this.mini) {
            cls.push(`is-mini is-mini--${this.itSelf ? 'it-self' : 'hover'}`);
        }
        if (this.full) {
            cls.push(`is-full is-full--${this.itSelf ? 'it-self' : 'hover'}`);
        }
        if (this.grayScale) {
            cls.push('is-gray-scale');
        }
        if (this.contain) {
            cls.push('is-contain');
        }
        if (this.ratio) {
            cls.push('is-ratio');
        }

        // Remove `y-image` class
        cls.shift();
        return cls;
    }

    /**
     * Return the class of the image.
     *
     * @returns {Array}
     */
    get imageClass(): Array<string> {
        const cls: Array<string> = [config.prefix.image];
        if (this.closeable) {
            cls.push('is-close');
        }
        if (this.circle) {
            cls.push('is-circle');
        }

        return cls;
    }

    /**
     * Emitted for image action.
     *
     * @param {string} node - click node
     * @returns {string}
     */
    @Emit('click')
    action(node: string | Record<string, unknown>): Record<string, unknown> | string {
        if (this.method) {
            this.method();
        }
        return node;
    }

    /**
     * Emit close event on callback.
     *
     * @returns {boolean}
     */
    @Emit('close')
    close(): boolean {
        if (this.hiddenAble) {
            this.display = false;
        }
        return this.display;
    }
}

export default YImage;
